export default __webpack_public_path__ + "static/ely-2-be493498c5b92066bf9628f02984c6d2.jpg";